<template>
    <div class="questionnaire">
        <div v-show="loading === false">
            <div class="header-result flex items-center justify-around">
                <div class="header-result-img">
                    <div class="header-img-result"><img class="illust-img-result" :src='this.img'/></div>
                </div>
                    <div class="header-result-name text-center flex flex-col items-center">
                        <div class="self-start uppercase font-normal text-2xl"><p>{{this.titleParent}}</p></div>
                        <div class="container-gamme-sku flex flex-row border-b-1">
                            <p v-if="this.gamme" class="illust-gamme-result illust pl-8 pr-8 text-white font-bold uppercase" :class="getGammeClass">{{ $t("Gamme")}} {{this.gamme}}</p>
                            <div class="illust-buttons-info-result">
                            <p v-if="this.sku" class="illust-sku-result illust pl-8 pr-8 bg-primary text-black font-bold">REF. {{this.sku}}</p>
                            </div>
                        </div>
                    </div>
            </div>
            <div v-if="stepNotice" class="text-warning-product"><p class="mt-6 mb-6 text-black p-2 text-left text-xs"><font-awesome-icon icon="fa-solid fa-circle-question" /> {{stepNotice}}</p></div>
            
<!-- Etape result par défault -->
            <div class="flex flex-col sm:flex-row flex-wrap py-4" v-if="(err == false && isString == false) || (err == true && isString == false)">
                <a v-show="flag" :href="product.link" v-for="(product, index) in stepAnswer" :key="index" class="cursor-pointer flex flex-col w-full lg:w-1/2 2xl:w-1/3  p-3 text-black">
                    <div class="main relative flex-auto flex-col border-solid border">

                        <div class="bloc-el-result flex flex-col justify-end items-center border-solid border-b">
                            <div class="contain-img-result duration-500 hover:opacity-75">
                                <img class="img-result my-4 object-contain rounded-bl-lg h-full" :src="product.image"/>
                            </div>
                            <div class="img-ref-result flex flex-col justify-center items-center">
                                <div class="titre-result mt-4 text-center mb-4"><p class="text-lg text-globaltext">{{product.name}}</p></div>
                                <p class="uppercase font-semibold text-xs mb-3">{{ $t("Reference") }} {{product.sku}}</p>
                            </div>
                        </div>

                        <div class="flex flex-col justify-center items-center gap-y-8 text-center p-8 product-price-desc">
                            <div class="font-semibold text-2xl product-price-pdr">{{prettyPrice(product.price)}}</div>
                            <div class="text-globaltext">{{product.description}}</div>
                            <button class="shadow-md uppercase border-solid border-b-2 border-t-0 border-l-0 border-r-0 border-globaltext rounded-md text-secondary bg-primary rounded-b-lg hover:text-primary hover:bg-opacity-0 duration-300 delay-250 px-8 py-2 absolute  bottom-3"><a class="link-product" :href="product.link">{{ $t("Ficheproduit") }}</a></button>
                        </div>

                    </div>
                </a>
                <p v-show="!flag" class="text-black">{{stepAnswer}}</p>
            </div>

<!-- Etape result en fonction du breadcrumb -->
            <div v-if="(isString == true) && (stepNotice) && ($store.state.steps[$store.state.steps.length -3] !== 'ref_brouette')" class="mainBox">
                    <a v-show="flag" :href="product.link" v-for="(product, index) in stepNotice" :key="index" class="cursor-pointer flex flex-col w-full lg:w-1/2 2xl:w-1/3  p-3 text-black">
                    <div class="main relative flex-auto flex-col border-solid border">
                        
                        <div class="bloc-el-result flex flex-col justify-end items-center border-solid border-b">
                            <div class="contain-img-result">
                                <img class="img-result my-4 object-contain rounded-bl-lg h-full" :src="product.image"/>
                            </div>
                            <div class="img-ref-result flex flex-col justify-center items-center">
                                <div class="titre-result mt-4 text-center mb-4"><p class="text-lg text-globaltext">{{product.name}}</p></div>
                                <p class="uppercase font-semibold text-xs mb-3">{{ $t("Reference") }} {{product.sku}}</p>
                            </div>
                        </div>

                        <div class="flex flex-col justify-center items-center gap-y-8 text-center p-8 product-price-desc">
                            <div class="font-semibold text-2xl product-price-pdr">{{prettyPrice(product.price)}}</div>
                            <div class="text-globaltext">{{product.description}}</div>
                            <button class="shadow-md uppercase border-solid border-b-2 border-t-0 border-l-0 border-r-0 border-globaltext rounded-md text-secondary bg-primary rounded-b-lg hover:text-primary hover:bg-opacity-0 duration-300 delay-250 px-8 py-2 absolute  bottom-3"><a class="link-product" :href="product.link">{{ $t("Ficheproduit") }}</a></button>
                        </div>

                    </div>
                    </a>
            </div>
        </div>

<!-- Etape result après input rempli -->
        <div v-if="(isString == true) && ($store.state.steps[$store.state.steps.length -3] === 'ref_brouette')" class="mainBox">
            <p class="text-black">{{stepAnswer}}.</p>
        </div>
        <div v-if="(isString == true) && ($store.state.steps[$store.state.steps.length -3] !== 'ref_brouette')" class="mainBox">
            <p class="text-black">{{stepAnswer}}</p>
        </div>

        <loader class="w-14 mx-auto" v-if="loading"></loader>
    </div>
</template>
<script>
import  i18n  from '../i18n';
import { getCurrentLang } from '../utils';
    export default {
        props: {
            datas: Object
        },
        data(){
            return {
                stepAnswer : null,
                stepAnswer2 : null,
                loading : false,
                err : false,
                isString : false,
                flag: false,
                img: '',
                titleParent: '',
                gamme:'',
                ean:'',
                sku:"",
                lang: ""
            }
        },
        watch:{
            loading : function(){
                
                if(this.loading)
                    this.$store.state.showPreviousBtn = false;
                else 
                    this.$store.state.showPreviousBtn = true;
            },
        },
        mounted () {
            if(this.stepAnswer && !this.isString){   
                var skus = this.stepAnswer.join();
                var typeItemUri = "";
            }
            if(this.$store.state.stepsAnswers[this.$store.state.stepsAnswers.length -2].value === "referenceRoueConnue"){
                typeItemUri = this.$store.state.apiUrlGetSparePartsbySku;
                skus = this.$store.state.refBrouetteConnue;
            }
            else{
                typeItemUri = this.$store.state.apiUrlGetProductsbySku;

            }


            if(skus){
                const lang = getCurrentLang()
                this.loading = true;
                const store = this.$store;
                this.$store.state.stepsAnswers[this.$store.state.stepsAnswers.length - 1].breadcrumbLabel = i18n.t("Resultat");
                this.axios
                .get(this.$store.state.apiUrlBase+typeItemUri+skus+"?lang="+lang)
                .then(response => {
                    if(response.data.pieceDeRechange !== undefined){ // Cas spécifique, on charge le nom du produit ainsi que son image
                        this.stepAnswer = response.data.pieceDeRechange;
                        this.sanitizeName = response.data.productData.name;
                        this.$store.state.stepsAnswers[this.$store.state.stepsAnswers.length - 1].breadcrumbLabel = this.sanitizeName;
                        this.img = response.data.productData.image;
                        this.titleParent = this.sanitizeName;
                        this.gamme = response.data.productData.gamme;
                        this.sku = response.data.productData.sku;

                    } else{
                        this.stepAnswer = response.data;
                    }
                    this.loading = false; // chargement terminé, afficher le dom
                    store.state.showPreviousBtn = true;
                    this.err = false;
                    this.isString = false;
                    this.flag = true;



                })
                .catch(error => {
                    this.stepAnswer = error.response.data.message;
                    this.err = true;
                    this.loading = false; // chargement terminé, afficher le dom
                    this.isString = true; // et donc erreur, permet d'afficher le le composant avec la réponse api
                    this.flag = true;
                })
            }
            this.$store.state.refBrouetteConnue = null;

        },
        methods:{
            prettyPrice : function(price){
                return new Intl.NumberFormat("fr-FR", {style: "currency", currency: "EUR"}).format(price);
            },
        },
        computed: {
            getGammeClass() {
                switch(this.gamme.toLowerCase()){
                    case  'first':
                        return 'bg-firstgamme'
                    case 'aktiv':
                        return 'bg-aktivgamme'
                    case  'pro select':
                        return 'bg-proselectgamme'
                    case  'technologies':
                        return 'bg-technologiesgamme'
                    case  'way of life':
                        return 'bg-wayoflifegamme'
                    case  'clipso®':
                        return 'bg-clipsogamme'
                    case  'rollax®':
                        return 'bg-diablesgamme'
                    case  'dévidoirs / rouleau':
                        return 'bg-devidoirsrouleaugamme'
                    default:
                        return ''
                }
            }
        },
        created(){
            this.stepAnswer = this.$store.state.stepsAnswers[this.$store.state.stepsAnswers.length - 1].answer;
            this.stepNotice = this.$store.state.stepsAnswers[this.$store.state.stepsAnswers.length - 1].notice;
            console.log(this.stepNotice)
            console.log(this.stepAnswer)
            this.isString = typeof(this.stepAnswer) === "string";


        },
    }
</script>
